import { Table, Tooltip, Typography } from 'antd';

import './SelectedProducts.less';
import { formatMDY } from 'utils/formatDate';

const SelectedProducts = ({
  productList,
  selectedRowKeys,
  handleRemoveProduct,
  onSelectProduct,
  setSelectedRowKeys,
  showCheckbox = true,
  hiddenDelete = false,
  ...restProps
}) => {
  const dataSource = productList?.map((product) => {
    return { ...product, key: product?.certificate?.linkId };
  });

  const onSelect = (product) => {
    const { certificate } = product;
    setSelectedRowKeys && setSelectedRowKeys([certificate?.linkId]);
    onSelectProduct && onSelectProduct(product);
  };

  const rowSelection = {
    selectedRowKeys,
    onSelect: onSelect,
    hideSelectAll: true,
  };

  const COLUMNS_TABLE = [
    {
      title: 'Product Name',
      dataIndex: 'productName',
      width: 200,
      render: (productName, record) => {
        return (
          <Typography.Text ellipsis={{ tooltip: productName }}>
            <a href={`/product/${record?.productId}`} target='_blank'>
              {productName}
            </a>
          </Typography.Text>
        );
      },
    },
    {
      title: 'GTIN',
      dataIndex: 'productGtin',
      width: 150,
    },
    {
      title: 'Certificate',
      dataIndex: ['certificate', 'certificate'],
      width: 150,
      render: (certificate, _) => {
        return (
          <Typography.Text ellipsis={{ tooltip: certificate }}>
            {certificate}
          </Typography.Text>
        );
      },
    },
    {
      title: 'Certificate Type',
      dataIndex: ['certificate', 'certificateType'],
      width: 150,
    },
    {
      title: 'Certificate Body',
      dataIndex: ['certificate', 'certificateBody'],
      width: 150,
      render: (certificateBody, _) => {
        return (
          <Typography.Text ellipsis={{ tooltip: certificateBody }}>
            {certificateBody}
          </Typography.Text>
        );
      },
    },
    {
      title: 'Expiry Date',
      dataIndex: ['certificate', 'certificateExpiryDate'],
      width: 150,
      render: (certificateExpiryDate, _) => {
        return (
          <Typography.Text
            ellipsis={{ tooltip: formatMDY(certificateExpiryDate) }}
          >
            {formatMDY(certificateExpiryDate)}
          </Typography.Text>
        );
      },
    },
    {
      width: 50,
      title: '',
      hidden: hiddenDelete,
      render: (_, record) => (
        <span
          onClick={() => handleRemoveProduct(record)}
          style={{ cursor: 'pointer', color: '#ff4d4f' }}
        >
          <Tooltip title='Remove from list'>X</Tooltip>
        </span>
      ),
    },
  ].filter((item) => !item.hidden);

  return (
    <div className='scroller' style={{ height: 'calc(100% - 30px)' }}>
      <Table
        className='select-product__table'
        scroll={{ y: 'auto', x: 1000 }}
        rowSelection={showCheckbox && rowSelection}
        columns={COLUMNS_TABLE}
        dataSource={dataSource}
        pagination={false}
        onRow={(product) => ({
          onClick: () => {
            onSelect(product);
          },
        })}
        {...restProps}
      />
    </div>
  );
};

export default SelectedProducts;
